import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { CommonService} from '../common.service';
import { UserIdleService } from 'angular-user-idle';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  constructor(private http: Http, private userIdle: UserIdleService, private commonService: CommonService) { }

  ngOnInit() {
     //Start watching for user inactivity.
     this.userIdle.startWatching();
     this.userIdle.onTimerStart().subscribe(count => (count));
     // Start watch when time is up.
     this.userIdle.onTimeout().subscribe(() => this.commonService.logout());
  }

}
